"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPasswordValidationSchema = exports.getPasswordFormFieldForErrorKey = exports.validatePassword = exports.failBySpecialCharacters = exports.failByNumbers = exports.failByDiffCaseLetters = exports.failBySpaceSymbols = exports.failByCyrillicSymbols = exports.failByPasswordMinLength = exports.failByMaxIdentCharsInARow = exports.fetchPasswordPolicy = exports.parsePasswordPolicy = exports.DEFAULT_PASSWORD_POLICY = void 0;
const yup_1 = require("yup");
exports.DEFAULT_PASSWORD_POLICY = {
    passwordMinLength: 8,
    useSpecialCharacters: false,
    useDiffCaseLetters: false,
    useNumbersInPassword: true,
    maxIdentCharsInARow: 2,
};
const POLICY_ERROR_KEYS = [
    "used_into_previous_password",
    "password_min_length",
    "diff_case_letters",
    "numbers_in_password",
    "special_characters",
    "max_ident_chars_in_a_row",
    "dict_word_password",
    "cyrillic_symbols",
    "space_symbols",
    "password",
];
const parsePasswordPolicy = (plc) => {
    if (!Array.isArray(plc) || plc.length < 5) {
        return Object.assign({}, exports.DEFAULT_PASSWORD_POLICY);
    }
    const passwordMinLength = Number(plc[0]);
    const maxIdentCharsInARow = Number(plc[4]);
    return {
        passwordMinLength: Number.isFinite(passwordMinLength)
            ? passwordMinLength
            : exports.DEFAULT_PASSWORD_POLICY.passwordMinLength,
        useSpecialCharacters: Number(plc[1]) === 1,
        useDiffCaseLetters: Number(plc[2]) === 1,
        useNumbersInPassword: Number(plc[3]) === 1,
        maxIdentCharsInARow: Number.isFinite(maxIdentCharsInARow)
            ? maxIdentCharsInARow
            : exports.DEFAULT_PASSWORD_POLICY.maxIdentCharsInARow,
    };
};
exports.parsePasswordPolicy = parsePasswordPolicy;
const fetchPasswordPolicy = async (fetchJson) => {
    const data = (await fetchJson({ url: "/auth/plc" }));
    return (0, exports.parsePasswordPolicy)(data === null || data === void 0 ? void 0 : data.plc);
};
exports.fetchPasswordPolicy = fetchPasswordPolicy;
const failByMaxIdentCharsInARow = (password, maxIdentCharsInARow) => {
    const regex = new RegExp(`(.)\\1{${maxIdentCharsInARow}}`);
    return regex.test(password);
};
exports.failByMaxIdentCharsInARow = failByMaxIdentCharsInARow;
const failByPasswordMinLength = (password, passwordMinLength) => {
    return password.length < passwordMinLength;
};
exports.failByPasswordMinLength = failByPasswordMinLength;
const failByCyrillicSymbols = (password) => {
    return /[А-Яа-яЁё]/.test(password);
};
exports.failByCyrillicSymbols = failByCyrillicSymbols;
const failBySpaceSymbols = (password) => {
    return /\s/.test(password);
};
exports.failBySpaceSymbols = failBySpaceSymbols;
const failByDiffCaseLetters = (password) => {
    return !(/\p{Uppercase}+/u.test(password) && /\p{Lowercase}+/u.test(password));
};
exports.failByDiffCaseLetters = failByDiffCaseLetters;
const failByNumbers = (password) => {
    return !/\p{Number}+/u.test(password);
};
exports.failByNumbers = failByNumbers;
const failBySpecialCharacters = (password) => {
    // eslint-disable-next-line prefer-regex-literals
    const regex = new RegExp(`[!"#$%&'()*+,-.\\/:;<=>?@\\[\\\\\\]^_\`{|}~]`);
    return !regex.test(password);
};
exports.failBySpecialCharacters = failBySpecialCharacters;
const validatePassword = (password, policy) => {
    if ((0, exports.failByCyrillicSymbols)(password)) {
        return "form.validations.cyrillic_symbols";
    }
    if ((0, exports.failBySpaceSymbols)(password)) {
        return "form.validations.space_symbols";
    }
    if ((0, exports.failByPasswordMinLength)(password, policy.passwordMinLength)) {
        return "form.validations.password_min_length";
    }
    if (policy.useDiffCaseLetters && (0, exports.failByDiffCaseLetters)(password)) {
        return "form.validations.diff_case_letters";
    }
    if (policy.useNumbersInPassword && (0, exports.failByNumbers)(password)) {
        return "form.validations.numbers_in_password";
    }
    if (policy.useSpecialCharacters && (0, exports.failBySpecialCharacters)(password)) {
        return "form.validations.special_characters";
    }
    if ((0, exports.failByMaxIdentCharsInARow)(password, policy.maxIdentCharsInARow)) {
        return "form.validations.max_ident_chars_in_a_row";
    }
    return null;
};
exports.validatePassword = validatePassword;
const getPasswordFormFieldForErrorKey = (key, passwordField, options) => {
    if (key === "unauthorized" && (options === null || options === void 0 ? void 0 : options.unauthorizedField)) {
        return options.unauthorizedField;
    }
    if (POLICY_ERROR_KEYS.includes(key) || key.toLowerCase().includes("password")) {
        return passwordField;
    }
    return key;
};
exports.getPasswordFormFieldForErrorKey = getPasswordFormFieldForErrorKey;
const createPasswordValidationSchema = (policy, options = {}) => {
    let schema = (0, yup_1.string)()
        .required("form.validations.valueMissing")
        .test("password-policy", (value, ctx) => {
        if (!value) {
            return true;
        }
        const message = (0, exports.validatePassword)(value, policy);
        return message ? ctx.createError({ message }) : true;
    });
    if (options.checkNotSameAsCurrent) {
        schema = schema.test("not-same-as-current", "form.validations.password", function (value) {
            const { currentPassword } = this.parent;
            return !value || value !== currentPassword;
        });
    }
    return schema;
};
exports.createPasswordValidationSchema = createPasswordValidationSchema;
//# sourceMappingURL=password.js.map